const BundlesPage = () => import('@/pages/bundles/BundlesPage.vue');

const routes = [
  {
    path: '/bundles',
    name: 'BundlesPage',
    id: 'bundles',
    component: BundlesPage,
    linkText: 'navBar.bundles',
    meta: { titleExtension: 'navBar.bundles' },
    index: 0,
  },
];

export default routes;
